import React from 'react';
import styles from './ContactDecor.module.css';

export function ContactBackdrop() {
  return (
    <div className={styles.contactBackdrop} aria-hidden="true">
      <div className={styles.contactGlow} />
      <div className={styles.contactMesh} />
      <svg
        className={styles.contactSvg}
        viewBox="0 0 1200 700"
        preserveAspectRatio="xMidYMid slice"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <radialGradient id="contactOrb" cx="30%" cy="65%" r="55%">
            <stop offset="0%" stopColor="#edc917" stopOpacity="0.1" />
            <stop offset="100%" stopColor="#000" stopOpacity="0" />
          </radialGradient>
          <linearGradient id="contactArc" x1="0%" y1="50%" x2="100%" y2="50%">
            <stop offset="0%" stopColor="#fff" stopOpacity="0" />
            <stop offset="50%" stopColor="#fff" stopOpacity="0.09" />
            <stop offset="100%" stopColor="#fff" stopOpacity="0" />
          </linearGradient>
        </defs>
        <rect width="1200" height="700" fill="url(#contactOrb)" />
        <path
          d="M-20 480 Q 200 380 420 440 T 780 400 T 1220 360"
          fill="none"
          stroke="url(#contactArc)"
          strokeWidth="1.2"
        />
        <g stroke="#fff" strokeOpacity="0.05" fill="none" strokeWidth="1">
          <path d="M80 120 L 1080 120" />
          <path d="M80 580 L 1080 580" />
        </g>
      </svg>
    </div>
  );
}

/** Abstract “reach out” graphic — matches home hero / M3 vector style */
export function ContactIllustration() {
  return (
    <div className={styles.contactIllustrationWrap} aria-hidden="true">
      <svg viewBox="0 0 440 120" xmlns="http://www.w3.org/2000/svg" className={styles.contactIllustrationSvg}>
        <defs>
          <linearGradient id="cill-accent" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#edc917" stopOpacity="0.5" />
            <stop offset="100%" stopColor="#edc917" stopOpacity="0.1" />
          </linearGradient>
        </defs>
        <rect x="48" y="28" width="200" height="64" rx="10" fill="#1e2028" stroke="#fff" strokeOpacity="0.1" />
        <path
          d="M48 36 L 148 72 L 248 36"
          fill="none"
          stroke="#fff"
          strokeOpacity="0.15"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <rect x="64" y="52" width="72" height="5" rx="2" fill="#fff" fillOpacity="0.08" />
        <rect x="64" y="64" width="120" height="5" rx="2" fill="#fff" fillOpacity="0.05" />
        <circle cx="332" cy="60" r="36" fill="#1e2028" stroke="#fff" strokeOpacity="0.1" />
        <path
          d="M318 52 L 332 64 L 352 48"
          fill="none"
          stroke="#edc917"
          strokeOpacity="0.7"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect x="292" y="102" width="80" height="3" rx="1" fill="url(#cill-accent)" />
      </svg>
    </div>
  );
}
